import { cn } from '~/utils/cn';

type Direction = 'positive' | 'negative' | 'neutral';

interface Props {
  value: string;
  direction?: Direction;
  className?: string;
}

const styles: Record<Direction, string> = {
  positive: 'bg-success-50 text-success',
  negative: 'bg-error-50 text-error',
  neutral: 'bg-neutral-20 text-neutral-70',
};

function inferDirection(value: string): Direction {
  const trimmed = value.trim();
  if (trimmed.startsWith('-')) return 'negative';
  if (trimmed.startsWith('+')) return 'positive';
  return 'neutral';
}

export function ExperimentLiftBadge({ value, direction, className }: Props) {
  const dir = direction ?? inferDirection(value);
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-medium',
        styles[dir],
        className,
      )}
    >
      {value}
    </span>
  );
}
